import React from 'react'

import { IMG } from '../../../themes'
import { cutString2, getDayNameBookingViewModal, getDateBookingViewModal } from '../../../helpers/functions'
import { BOOKING_STATUS, CREATE_BOOKING } from '../../../helpers/constants'
import Bullet from './Bullet'

const MoreViewModal = (props) => {
  const {
    language,
    date,
    bookings,
    onBookingView,
    onClose,
    colorTheme,
  } = props

  const bullet = (
    <Bullet
      colorTheme={colorTheme}
      width='10px'
      height='10px'
    />
  )

  return (
    <div className='card_more'>
      <div className='data-list'>
        <div className='action-button'>
          <div>
            <div className='day_more'>{getDayNameBookingViewModal(date)}</div>
            <img className='more_content_delete' src={IMG['close.svg']} onClick={onClose} alt='close' />
          </div>
          <div className='day_more_number'>{getDateBookingViewModal(date)}</div>
        </div>
  
        <div className='list_more'>
          {bookings.length > 0
            ? bookings.map((item, index) => (
              <div className={`title_more ${item.status === BOOKING_STATUS.IN_USE ? 'alive' : ''}`} key={`more-view-${index}`} onClick={() => onBookingView(item)}>
                {bullet}
                <span className='sub_title_more'>{cutString2(`${item.time} ${item.title}`, 25)}</span>
              </div>
            ))
            : (
              <div className='title_more'>
                {bullet}
                <span className='sub_title_more'>{CREATE_BOOKING.NO_DATA[language]}</span>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default MoreViewModal
